// eslint-disable-next-line
/* eslint-disable */


import request from './request'
import { api, apiTest, apiVoucher, apiWifi } from './config'
import { getToken, setToken, removeToken } from '../store/auth'

// const auth = {
//     headers: {getToken()} 
// }

export default {
    atendente: {

        retornarProximoIdAtendimento() { //ok            
            console.log(id);
            //return api.get('/atendente/retornarProximoIdAtendimento/')
            return request({
                url: '/atendente/retornarProximoIdAtendimento/',
                method: 'get',
            })
        },

        retornarServico() { //ok            
            //return api.get('/atendente/retornarServicos/'+id)
            return request({
                url: '/atendente/retornarServicos/',
                method: 'get'
            })
        },

        retornarLocais(idUnidade) {

            return request({
                url: `/atendente/retornarLocais?idUnidade=${idUnidade}`,
                method: 'get'
            })
        },

        retornarMedicos() {
            // console.log(id);            
            return api.get('/atendente/retornarMedicos/')
        },
        refreshToken(token) {
            return request({
                url: '/atendente/refreshToken',
                method: 'post',
                data: token
            })
        },
        cadastrarConsultas(servicos, prioridade, emergencia, codigoSigla, nomePaciente = '', idLocal) { //ok
            var obj = {
                servicos: servicos,
                prioridade: prioridade,
                emergencia: emergencia,
                codigoSigla: codigoSigla,
                nomePaciente: nomePaciente,
                idLocal: idLocal
            }

            return request({
                url: '/atendente/cadastrarConsultas/',
                method: 'post',
                data: obj
            })
        },
        buscarPrimeiroUsuarioValido () {
           return apiWifi.get('/user/firstId')
        },
        gerarSenhaWifi(user) {
            return apiWifi.get(`user/id/${user}`)
        }
    }
}